import { render, staticRenderFns } from "./UniversalInput.vue?vue&type=template&id=b8df61b2&scoped=true&"
import script from "./UniversalInput.vue?vue&type=script&lang=js&"
export * from "./UniversalInput.vue?vue&type=script&lang=js&"
import style0 from "./UniversalInput.vue?vue&type=style&index=0&id=b8df61b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8df61b2",
  null
  
)

export default component.exports